import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty, map, cloneDeep, startCase, isUndefined } from 'lodash'
import { FaMinusSquare } from 'react-icons/fa'
import Component from '../common/Component'
import TextField from '../common/TextField'

export default class BenefitsSetJsonTable extends Component {
  static propTypes = {
    name: PropTypes.string,
    valueObject: PropTypes.object,
    valueArray: PropTypes.array,
    tableHeader: PropTypes.array,
    tableRow: PropTypes.array,
    handleChange: PropTypes.func,
    disableEdit: PropTypes.bool
  }

  constructor(props) {
    super(props)
    const rowValues = {}
    const { tableRow, valueObject, valueArray } = this.props

    if (tableRow) {
      tableRow.forEach((row) => {
        rowValues[row] = !isEmpty(valueObject) ? valueObject[row] : {}
      })
    } else if (valueArray) {
      valueArray.forEach((row, index) => {
        rowValues[index] = !isEmpty(valueArray) ? valueArray[index] : {}
      })
    }

    this.state = { values: rowValues, newValue: {} }
  }

  componentDidUpdate() {
    if (this.state.lastFieldEdited) {
      const fieldEdited = document.querySelector(`input[name='${this.state.lastFieldEdited}']`)
      if (fieldEdited !== null) {
        fieldEdited.focus()
      }
    }
  }

  get headerRow() {
    const { tableHeader, tableRow, name, disableEdit } = this.props

    const header = map(tableHeader, (value) => {
      return (<th key={`${name}_${value}_header`}>{startCase(value)}</th>)
    })
    return (
      <thead>
        <tr>
          {header}
          {!disableEdit && !tableRow && <th width="2%" />}
        </tr>
      </thead>
    )
  }

  get dynamicRows() {
    const { tableHeader, name, disableEdit } = this.props

    const rows = map(this.state.values, (row, index) => {
      const rowData = []
      map(tableHeader, (header) => {
        rowData.push(
          <td key={`${name}_${index}_${header}`}>
            <TextField
              key={`${index}_${header}`}
              name={`${index}_${header}`}
              disabled={disableEdit}
              handleChange={this.handleChange}
              value={this.state.values[index][header]}
            />
          </td>
        )
      })
      return (
        <tr key={`${name}_${index}`}>
          {rowData}
          {!disableEdit && this.deleteButton(`${index}_${name}`) }
        </tr>
      )
    })

    return rows
  }

  get rows() {
    const { tableHeader, tableRow, name, disableEdit } = this.props

    if (!tableRow) {
      return (
        <tbody>
          {this.dynamicRows}
          {!disableEdit && !tableRow && this.addRow}
        </tbody>
      )
    }

    const fixedRows = map(tableRow, (row) => {
      const rowData = []
      map(tableHeader, (header, index) => {
        if (index === 0) {
          rowData.push(<td key={`${name}_${row}_${header}`}>{row}</td>)
        } else {
          rowData.push(
            <td key={`${name}_${row}_${header}`}>
              <TextField
                key={`${row}_${header}`}
                name={`${row}_${header}`}
                disabled={disableEdit}
                handleChange={this.handleChange}
                value={this.state.values[row][header]}
              />
            </td>
          )
        }
      })

      return (
        <tr key={`${name}_${row}`}>
          {rowData}
        </tr>
      )
    })

    return (
      <tbody>
        {fixedRows}
        {!disableEdit && !tableRow && this.addRow}
      </tbody>
    )
  }

  get addRow() {
    const { name, tableHeader } = this.props
    const rowData = []
    const index = Object.keys(this.state.values).length
    map(tableHeader, (header) => {
      rowData.push(
        <td key={`${name}_${index}_${header}`}>
          <TextField
            key={`${index}_${header}`}
            name={`${index}_${header}`}
            disabled={false}
            handleChange={this.handleAddRowChange}
            value={this.state.newValue[header]}
          />
        </td>
      )
    })
    rowData.push(<td key={`${name}_${index}_space`} width="2%" />)
    return (
      <tr key={`${name}_${index}`}>
        {rowData}
      </tr>
    )
  }

  handleChange = (field, value) => {
    const { name, tableRow } = this.props
    const rowHeader = field.split('_')
    const row = rowHeader[0]
    const header = rowHeader.slice(1).join('_')

    this.setState((prevState) => {
      const newValues = cloneDeep(prevState.values)

      if (isUndefined(newValues[row])) {
        newValues[row] = {}
      }

      newValues[row][header] = value
      if (tableRow) {
        this.props.handleChange(name, newValues)
      } else {
        this.props.handleChange(name, Object.values(newValues))
      }
      return { values: newValues, lastFieldEdited: field }
    })
  }

  handleAddRowChange = (field, value) => {
    const { name } = this.props

    const rowHeader = field.split('_')
    const header = rowHeader.slice(1).join('_')
    this.setState((prevState) => {
      const newValues = cloneDeep(prevState.values)
      const newValue = cloneDeep(prevState.newValue)

      const index = Object.keys(newValues).length

      newValue[header] = value
      newValues[index] = newValue

      this.props.handleChange(name, Object.values(newValues))

      return { values: newValues, newValue: {}, lastFieldEdited: field }
    })
  }

  handleDeleteRow = (event, key) => {
    const { name } = this.props
    const rowHeader = key.split('_')
    const index = rowHeader[0]
    this.setState((prevState) => {
      const newValues = cloneDeep(prevState.values)

      delete newValues[index]

      this.props.handleChange(name, Object.values(newValues))
      return { values: newValues, lastFieldEdited: null }
    })
  }

  deleteButton(key) {
    return (
      <td key={`metadata_action_${key}`} style={{ textAlign: 'center' }}>
        <button
          type="button"
          id={key}
          onClick={(event) => this.handleDeleteRow(event, key)}
        > <FaMinusSquare className="error" />
        </button>
      </td>
    )
  }

  render() {
    return (
      <div className="full-width-table-container">
        <table className="pure-table full-width-table index-table json-table">
          {this.headerRow}
          {this.rows}
        </table>
      </div>
    )
  }
}
